import { render, staticRenderFns } from "./ListOfPeriods.vue?vue&type=template&id=2ef9a833&scoped=true"
import script from "./ListOfPeriods.vue?vue&type=script&lang=js"
export * from "./ListOfPeriods.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef9a833",
  null
  
)

export default component.exports